
import React from "react";
import { X } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

export default function BaseModal({
  open,
  onClose,
  onCloseX,
  title,
  children,
  onCancel,
  onConfirm,
  size = "md",
  hideCloseButton = false,
  textBtn = "Add",
  variant = "default",
  separator=true,
  classNameBtn,
  classNameBody,
  classNameContent,
  footer=true,
  loading,
  disabled = false,
  textCancel="Cancel",
  dir,
}) {
  const sizeClasses = {
    sm: "sm:max-w-sm",
    md: "sm:max-w-lg",
    lg: "sm:max-w-2xl",
    xl: "sm:max-w-9xl",
  };

  return (
    <Dialog open={open} onOpenChange={(state) => !state && onClose?.()} >
      <DialogContent
        dir={dir}
        className={twMerge(
          `p-0 rounded-2xl shadow-xl w-full
           bg-white max-h-[90vh] 
          scroll-y
          flex flex-col ${classNameContent}`,
          sizeClasses[size]
        )}
      >
        {/*======== Header ========*/}
        {(title) && (
          <DialogHeader className="flex flex-row items-center justify-between shrink-0 px-6 pt-7">
            {title && (
              <DialogTitle className="text-lg font-semibold text-gray-900 text-start">
                {title}
              </DialogTitle>
            )}
            
            {!hideCloseButton && (
              <button
                onClick={onClose||onCloseX}
                className="p-1 rounded-md hover:bg-gray-100 transition-colors"
              >
                <X className="w-5 h-5 text-gray-600" />
              </button>
              
            )}
          </DialogHeader>

        )}
        {separator&&<hr className="max-w-xxl mx-6 h-0.3 shrink-0 bg-[#D2DAE7]"/>}
        
        {/*======== Body ========*/}
        <div className={`flex-1 min-h-0 px-6 pt-[2px] pb-2 mx-2 mb-3 scroll-y ${classNameBody}`}>{children}</div>

        {/* ======== Footer ========*/}
        {footer&&<DialogFooter className="border-t border-gray-200 px-6 py-4 shrink-0 flex justify-end gap-3 ">
          
          <Button
            variant="outline"
            className="px-9 h-[2.625rem] border-none !text-blue-300"
            onClick={() => {
              onCancel?.();
              onClose?.();
            }}
          >
            {textCancel}
          </Button>
          <Button
          type="submit"
            variant={variant}
            loading={loading}
            disabled={disabled}
            className={`px-9 h-[2.625rem] ${classNameBtn}`}
            onClick={() => onConfirm?.()}
          >
            {textBtn}
          </Button>
        </DialogFooter>}
        
      </DialogContent>
    </Dialog>
  );
}
